import { useEffect } from "react";

import useToggleState from "./useToggleState";

const useModalToggle = () => {
  const {
    value: active,
    toggle: toggleActive,
    setOn: activate,
    setOff: deactivate,
  } = useToggleState();

  useEffect(() => {
    if (active) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "initial";
    }
  }, [active]);

  return {
    active,
    toggleActive,
    activate,
    deactivate,
  };
};

export default useModalToggle;
